'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("compteEditionService", function ($modal) {
  var popinParams = {
    controller: "CompteEditionPopinController",
    template: require("./compteEditionPopin.html"),
    options: {
      width: 1000
    }
  };
  return {
    openEditionPopin: function openEditionPopin($scope, compte) {
      console.log('BUILD openEditionPopin', compte);
      return $modal.open(_.extend({}, popinParams, {
        scope: $scope,
        vars: {
          edit: compte ? true : false,
          compteId: compte && compte.id
        },
        options: {
          width: 950
        }
      }));
    },
    openCreationFilialePopin: function openCreationFilialePopin($scope, compteParent) {
      return $modal.open(_.extend({}, popinParams, {
        scope: $scope,
        vars: {
          edit: false,
          compteParentId: compteParent.id,
          compteParentNomInterne: compteParent.nomInterne,
          compteParent: compteParent
        },
        options: {
          width: 950
        }
      }));
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/edition/compteEditionService.js
// module id = 2781
// module chunks = 13